import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.75 15C8.75 13.2051 10.2051 11.75 12 11.75C13.7949 11.75 15.25 13.2051 15.25 15C15.25 16.7949 13.7949 18.25 12 18.25C10.2051 18.25 8.75 16.7949 8.75 15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 1H3L3 23L21 23L21 1ZM12 9.75C14.8995 9.75 17.25 12.1005 17.25 15C17.25 17.8995 14.8995 20.25 12 20.25C9.1005 20.25 6.75 17.8995 6.75 15C6.75 12.1005 9.1005 9.75 12 9.75ZM10.9961 4.99609H13V7H10.9961V4.99609Z"}}]};

const AudioFilled = Vue.extend<IconProps>({
  name: 'AudioFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'audio-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AudioFilled;
